import type { ImportBody } from './types';

const BODY_FIELD_SOURCE_KEYS: Record<string, string> = {
  tk_spdd: 'tk_dd',
  tk_cpnvl: 'tk_cp_nvl'
};

export const toPartialUpdateBody = (body: ImportBody, mainData: Record<string, unknown[]>): ImportBody =>
  Object.fromEntries(
    Object.entries(body).filter(([field]) => {
      if (field === 'uuid') return true;
      const sourceKey = BODY_FIELD_SOURCE_KEYS[field] || field;
      return sourceKey in mainData;
    })
  ) as ImportBody;
